import { Injectable, EventEmitter } from "@angular/core";
import { IGridViewMetadata, IMetadataAction } from "@tylertech/tyler-api-types";
import { Utilities } from "@tylertech/shared-module";
import
{
    GridLoadService,
    MetadataActionService,
    MetadataViewService,
    ProviderStorageService,
} from "../../services";
import { RowCommandArgs, RepositoryFormData, RowCommandRow } from "../../interfaces";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { ErrorInfo } from "@tylertech/core-module";
import { MetadataActionHelpers } from "../../utilities";
import { GridEventService } from "./gridEvent.service";
@Injectable({ providedIn: "root" })
export class GridActionService
{
    constructor(
        private $metadataActionService: MetadataActionService,
        private readonly $metadataViewService: MetadataViewService,
        private $providerStorageService: ProviderStorageService,
        private readonly $commonDialogsService: CommonDialogsService,
        private readonly $gridEventService: GridEventService,
        private readonly $gridLoadService: GridLoadService
    ) { }

    PerformMetadataAction(
        providerId: string,
        row: any,
        action: IMetadataAction,
        datacontroller: RepositoryFormData,
        viewMetadata: IGridViewMetadata,
        repositoryFunction: EventEmitter<RowCommandArgs>
    ): Promise<void>
    {
        const repositoryFormData = this.getDataController(action, row["$$model"], datacontroller);
        return this.$metadataActionService
            .ExecuteAction(row["$$model"], action, repositoryFormData)
            .then(x =>
            {
                if (Utilities.IsNullOrUndefined(x)) return;
                if (MetadataActionHelpers.isReturnPathThis(action))
                {
                    if (x["IsDeleted"])
                    {
                        const rows = this.$providerStorageService.GridData[providerId];
                        const index = rows.indexOf(row);
                        if (index > -1)
                        {
                            repositoryFunction.emit(<RowCommandArgs>{
                                command: "Delete",
                                row: <RowCommandRow>{
                                    id: row.Id,
                                    model: row["$$model"],
                                },
                            });
                        }
                        return;
                    }
                    if (!("RowTypeName" in viewMetadata.GridProperties))
                    {
                        row["$$model"] = x;
                        this.$gridLoadService.fireModelChangedListeners(providerId);
                    }

                    viewMetadata["$columns"].forEach(column =>
                    {
                        row[column.Name] = x[column.Name] || row[column.Name];
                    });
                    this.$gridEventService.fireFetchTable();
                }
            })
            .catch(x =>
            {
                const errorInfo: ErrorInfo = x.data;
                const msg = errorInfo.Message.replace(/(?:\r\n|\r|\n)/g, "<br>");
                this.$commonDialogsService.showAlertHtmlMessage(msg, "Error");
            });
    }

    private getDataController(
        action: IMetadataAction,
        model: any,
        datacontroller: RepositoryFormData
    ): RepositoryFormData
    {
        let type = model.$$TypeName;
        if (Utilities.IsNullOrUndefined(action)) new RepositoryFormData(null, null);
        if (!Utilities.IsNullOrUndefined(datacontroller)) return datacontroller;
        if (!Utilities.IsNullOrUndefined(action.ViewToShow))
            type = this.$metadataViewService.GetTypeName(action.ViewToShow);
        if (type) return new RepositoryFormData(type, model);
    }
}
